import sha256 from 'crypto-js/sha256'
import aes from 'crypto-js/aes'
import utf8 from 'crypto-js/enc-utf8'
import base64 from 'crypto-js/enc-base64'
import ecb from 'crypto-js/mode-ecb'
import { DEPLOY_ENV } from '@/defines/env'
import { getSource, MALL_STR, MALL_NEW_STR } from './common_params'

import { salts, saltsType2, saltsType3 } from './calc_salt_sign/salts'
import {
  getPosFromSaltIndex,
  getType3SaltIndexPos
} from './calc_salt_sign/utils'

/**
 * 是否需要加密方法
 * @param {object} encryption 加密索引
 */
export const isEncryptedResponse = (encryption = {}) => {
  return encryption.salt_index !== undefined && encryption.salt_index !== -1
}

export const decryptFnType1 = (data, { salt_index: saltIndex }) => {
  const envKey = DEPLOY_ENV === 'test' ? 'test' : 'online'
  const salt = sha256(salts[envKey][saltIndex]).toString().substring(0, 16)
  const result = aes
    .decrypt(
      {
        ciphertext: base64.parse(data)
      },
      utf8.parse(salt),
      {
        mode: ecb
      }
    )
    .toString(utf8)
  try {
    return {
      data: JSON.parse(result)
    }
  } catch (error) {
    return {
      data
    }
  }
}

export const decryptFnType2 = (data, { salt_index: saltIndex }) => {
  const { keyIndex, keyStartIndex, keyEndIndex } =
    getPosFromSaltIndex(saltIndex)
  const decrypt = saltsType2[keyIndex]
    .toString()
    .substring(keyStartIndex, keyEndIndex)
  const salt = sha256(decrypt + getSource() + MALL_STR)
    .toString()
    .substring(0, 16)
  const result = aes
    .decrypt(
      {
        ciphertext: base64.parse(data)
      },
      utf8.parse(salt),
      {
        mode: ecb
      }
    )
    .toString(utf8)
  try {
    return {
      data: JSON.parse(result)
    }
  } catch (error) {
    return {
      data
    }
  }
}

/**
 * type3 解密数据
 * @param {*} data 加密数据
 * @param {number} saltIndex 密钥索引
 */
export const decryptFnType3 = (data, { salt_index: saltIndex }) => {
  const { keyStartIndex, keyEndIndex } = getType3SaltIndexPos(saltIndex)
  const decrypt = saltsType3.toString().substring(keyStartIndex, keyEndIndex)
  const salt = sha256(decrypt + getSource() + MALL_NEW_STR)
    .toString()
    .substring(0, 16)
  const result = aes
    .decrypt(
      {
        ciphertext: base64.parse(data)
      },
      utf8.parse(salt),
      {
        mode: ecb
      }
    )
    .toString(utf8)

  try {
    return {
      data: JSON.parse(result)
    }
  } catch (error) {
    return {
      data
    }
  }
}
